export default __webpack_public_path__ + "static/media/GraphikLCWeb-Regular.0c466a7d.woff";